import type { ReusedOptions } from '../../../types/ReusedOptions.js';

/**
 * Options for the `cloudpack bundle` command.
 */
export interface BundleOptions extends Pick<ReusedOptions, 'bundler' | 'logBundleInfo' | 'match' | 'mode'> {
  /**
   * Disables source maps.
   */
  disableSourceMaps?: boolean;

  /**
   * Path for the bundle output. This is usually relative to the app path.
   * If `package` is set, it's relative to the package path.
   *
   * If not set, the bundle output is dropped in the default path under the cloudpack cache.
   */
  outdir?: string;

  /**
   * @deprecated Removed in favor of `match`.
   */
  package?: string;
}
